import { DefaultTheme, css } from 'styled-components';

/**
 * Styles for the block and inline elements learner markdown can contain (mems
 * and nuggets). Colours are inherited from the container so the same rules
 * work on a plain card and on text laid over a mem image.
 */
export const memMarkdownContent = (theme: DefaultTheme) => css`
  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  p,
  ul,
  ol,
  blockquote,
  pre,
  table {
    margin: 0 0 ${theme.sz.s2};
    max-width: none;
  }

  /* Soft line breaks inside a block are meaningful in a mem. */
  p,
  li {
    white-space: pre-line;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0 0 ${theme.sz.s1};
    font-size: 1em;
    font-weight: 700;
  }

  ul,
  ol {
    padding-left: ${theme.sz.s4};
  }

  li {
    margin: 0;
  }

  li > input[type='checkbox'] {
    margin-right: ${theme.sz.s1};
  }

  mark {
    background-color: ${theme.co.warning90};
    color: ${theme.co.neutral10};
    border-radius: ${theme.bo.small};
    padding: 0 0.15em;
  }

  u {
    text-decoration: underline;
  }

  ruby {
    ruby-position: over;
    ruby-align: center;
  }

  rt {
    font-size: 0.6em;
  }

  a {
    color: inherit;
    text-decoration: underline;
  }

  blockquote {
    border-left: ${theme.bo.mediumWidth} solid currentColor;
    padding-left: ${theme.sz.s2};
    opacity: 0.8;
  }

  code {
    font-family: monospace;
    font-size: 0.9em;
  }

  pre {
    white-space: pre-wrap;
  }

  th,
  td {
    border: 1px solid currentColor;
    padding: 0 ${theme.sz.s1};
  }

  hr {
    border: none;
    border-top: 1px solid currentColor;
    opacity: 0.4;
    margin: ${theme.sz.s2} 0;
  }

  img {
    max-width: 100%;
  }
`;
